// GENERATED FILE — do not edit, do not commit (see .gitignore).
// Written by frontend/scripts/generate-version.js on install and on every build.
export const buildInfo = {
  commit: 'ca4b663',
  branch: 'prod-new',
  buildDate: '2026-11-04T15:56:59.605Z',
  dirty: true,
} as const;
